import { Tag } from 'antd';
import React from 'react';
import { useObservable } from 'react-use-observable';
import { refundRequestFactory } from 'v2/services/shopping/refundRequest';

import type { IRefundRequest, IShoppingProduct } from 'v2/interfaces/shopping';

import useStyle from '../styles';

interface IDefaultDataProps {
  shopping: IShoppingProduct;
}

export function BuyerDetails({ shopping }: IDefaultDataProps) {
  const [refundRequest] = useObservable<IRefundRequest>(() => refundRequestFactory.buyerFindRefundByInvoiceId(shopping.invoice_id), []);

  const classes = useStyle();

  return (
    <div className={classes.sender}>
      {shopping.customer.name && (
        <div className='data'>
          <span>Nome:</span> {shopping.customer.name}
        </div>
      )}
      {shopping.customer.email && (
        <div className='data'>
          <span>E-mail:</span> {shopping.customer.email}
        </div>
      )}
      {shopping.customer.celphone && (
        <div className='data'>
          <span>Fone:</span> {shopping.customer.celphone}
        </div>
      )}
      {shopping.payment_method.name && (
        <div className='data'>
          <span>Forma de pagamento:</span> {shopping.payment_method.name}
        </div>
      )}
      {shopping.card_number && (
        <div className='data'>
          <span>Cartão:</span> {shopping.card_number}
        </div>
      )}
      {!refundRequest?.exist && refundRequest?.refund_due_date && (
        <div className='data'>
          <span>
            Prazo para reembolso: {refundRequest?.refund_due_date} {refundRequest?.expired && <Tag color='red'>Expirado</Tag>}
          </span>
        </div>
      )}
    </div>
  );
}
